module.exports = {"body":"<!DOCTYPE HTML>\n<html lang=\"en-US\">\n    <head>\n        <meta charset=\"UTF-8\">\n        <meta http-equiv=\"refresh\" content=\"1;url=http://dc402.org/files/omahaminimakerfaire2018/\">\n        <script type=\"text/javascript\">\n            window.location.href = \"http://dc402.org/files/omahaminimakerfaire2018/\"\n        </script>\n        <title>Crappy Github pages poor-man's URL shortener</title>\n    </head>\n    <body>\n        If you are not redirected automatically, follow the <a href='http://dc402.org/files/omahaminimakerfaire2018/'>link</a>.\n    </body>\n</html>\n"}


//////////////////
// WEBPACK FOOTER
// ./r/1/index.html
// module id = 445
// module chunks = 0